import PlaceholderB from "../../../../assets/components/PlaceholderB"

// ──────────────────────────────────────────────
// Step1 : 제목 입력
// ──────────────────────────────────────────────
const Reserve1 = ({ title, setTitle, hasStep1 }) => {
  const maxLen = 20;

  return (
    <div className="p-[16px]">
      <h2 className="text-t2 text-text-default pb-[8px]">알림 제목</h2>
      <p className="text-b1 text-text-subtler pb-[32px]">
        작성된 제목이 푸시 알림으로 표시돼요.
      </p>

      <PlaceholderB
        label=""
        placeholder="예) 아메리카노 1000원 행사"
        value={title}
        onChange={(e) =>
          e.target.value.length <= maxLen && setTitle(e.target.value)
        }
        maxLength={20}
        showCounter
        rightIconMode="clear"
      />
    </div>
  );
};

export default Reserve1;